import { render, staticRenderFns } from "./AddUnitItemModal.vue?vue&type=template&id=bbd814d2&scoped=true"
import script from "./AddUnitItemModal.vue?vue&type=script&lang=js"
export * from "./AddUnitItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd814d2",
  null
  
)

export default component.exports